import EstadoDocumento from "common/components/EstadoDocumento/EstadoDocumento"
import { ESTADO_REVISION_FACTURAS_RECURRENTES_PROPERTIES } from "common/utils/constants"
import { formatDate } from "common/utils/date"
import { formatSerieAndNumero } from "common/utils/formats"

export const getEstadoFormatter = (
  factura: $TSMigrationFixMe,
  columnKey: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return (
    // eslint-disable-next-line react/react-in-jsx-scope, react/jsx-filename-extension
    <EstadoDocumento
      color={
        ESTADO_REVISION_FACTURAS_RECURRENTES_PROPERTIES(t)[factura[columnKey]]
          .color
      }
      text={
        ESTADO_REVISION_FACTURAS_RECURRENTES_PROPERTIES(t)[factura[columnKey]]
          .text
      }
      backgroundColor={
        ESTADO_REVISION_FACTURAS_RECURRENTES_PROPERTIES(t)[factura[columnKey]]
          .backgroundColor
      }
      background
      fontSize='14px'
      width='100%'
      padding='5px'
    />
  )
}

export const FormatDocumentoComercial = ({
  serie,
  numero,
  facturaNumero,
}: $TSMigrationFixMe) => {
  return formatSerieAndNumero({
    serie,
    numero,
    facturaNumero,
  })
}

export const getPriceFormated = (price: $TSMigrationFixMe) => {
  return price?.toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const INTERVALOS_KEYS = (t: $TSMigrationFixMe) => {
  // TODO: i18n
  return {
    1: { label: `${t("documentos.facturaRec.tab.diaryLabel")}`, value: 1 },
    7: { label: `${t("documentos.facturaRec.tab.weeklLabel")}`, value: 7 },
    15: {
      label: `${t("documentos.facturaRec.tab.fortnightLabel")}`,
      value: 15,
    },
    30: { label: `${t("documentos.facturaRec.tab.mensualLabel")}`, value: 30 },
    60: {
      label: `${t("documentos.facturaRec.tab.bimestralLabel")}`,
      value: 60,
    },
    90: {
      label: `${t("documentos.facturaRec.tab.trimestreLabel")}`,
      value: 90,
    },
    180: {
      label: `${t("documentos.facturaRec.tab.semestreLabel")}`,
      value: 180,
    },
    365: { label: `${t("documentos.facturaRec.tab.anualLabel")}`, value: 365 },
  }
}

export const INTERVALOS_KEYS_ARRAY = (t: $TSMigrationFixMe) =>
  [
    INTERVALOS_KEYS(t)[1],
    INTERVALOS_KEYS(t)[7],
    INTERVALOS_KEYS(t)[15],
    INTERVALOS_KEYS(t)[30],
    INTERVALOS_KEYS(t)[60],
    INTERVALOS_KEYS(t)[90],
    INTERVALOS_KEYS(t)[180],
    INTERVALOS_KEYS(t)[365],
  ].map((element) => ({
    name: element.label,
    value: element.value,
  }))
export const mapFacturaRecurrenteInfo = (
  facturaRecurrente: $TSMigrationFixMe
) => {
  return {
    intervalo: facturaRecurrente?.intervalo,
    fechaInicio: facturaRecurrente?.fechaInicio,
    fechaFin: facturaRecurrente?.fechaFin,
    numeroFicherosAdjuntos: facturaRecurrente?.numeroAdjuntos,
    importe: facturaRecurrente?.importe,
    razonSocial: facturaRecurrente?.usuario?.razonSocial,
    cuentaContable: facturaRecurrente.cuentaContable,
  }
}

export const COLUMNS_RECURRETES_HISTORICO = [
  {
    label: "Fecha",
    key: "fechaOperacion",
    format: formatDate,
    className: "",
  },
  {
    label: "Importe",
    key: "importe",
    format: getPriceFormated,
    className: "",
  },
  {
    label: "",
    key: "numeroDocumentoComercial",
    format: (values: $TSMigrationFixMe) =>
      values && FormatDocumentoComercial(values),
    className: "serie",
  },
  {
    label: "Estado",
    key: "estado",
    className: "",
  },
]

export const onGetColumns = (
  handleOpenFacturaComercial: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const COLUMNS = [
    {
      label: `${t("documentos.facturaRec.idView.tab.headerDate")}`,
      key: "fechaOperacion",
      format: (factura: $TSMigrationFixMe) =>
        factura && formatDate(factura.fechaOperacion),
      className: "",
    },
    {
      label: `${t("documentos.facturaRec.idView.tab.headerImport")}`,
      key: "importe",
      format: (factura: $TSMigrationFixMe) =>
        factura && getPriceFormated(factura.importe),
      className: "",
    },
    {
      label: `${t("documentos.facturaRec.idView.tab.headerSerie")}`,
      key: "serieNumero",
      format: (factura: $TSMigrationFixMe) => factura.serieNumero,
      className: "serie",
      onClick: (factura: $TSMigrationFixMe) => {
        return (
          factura.serieNumero && handleOpenFacturaComercial(factura.facturaId)
        )
      },
    },
    {
      label: `${t("documentos.facturaRec.idView.tab.headerState")}`,
      key: "estado",
      className: "estado",
      format: (factura: $TSMigrationFixMe) =>
        getEstadoFormatter(factura, "estado", t),
    },
  ]
  return COLUMNS
}

export const onRenderDate = (date: $TSMigrationFixMe) => {
  if (date) {
    return formatDate(date)
  }

  return "-"
}

export const getArchivosAdjuntosFormated = (numArchivos: $TSMigrationFixMe) => {
  return `${numArchivos} archivos`
}
export const formatInterval = (
  t: $TSMigrationFixMe,
  intervalo: $TSMigrationFixMe
) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  return intervalo ? INTERVALOS_KEYS(t)[intervalo].label : ""
}

export const FECHAS_RECURRENTES_KEYS = {
  fechaInicio: "fechaInicio",
  fechaFin: "fechaFin",
  fechaProximaFactura: "fechaProximaFactura",
} as const

export type FechasRecurrentesKeys = keyof typeof FECHAS_RECURRENTES_KEYS

export const getColumnasDetalleRecurrentes = (
  openModalAdjuntos: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return [
    {
      label: `${t("documentos.facturaRec.idView.intervalLabel")}`,
      key: "intervalo",
      format: (intervalo: $TSMigrationFixMe) => formatInterval(t, intervalo),
      className: "highlighted-box",
    },
    {
      label: `${t("documentos.facturaRec.idView.initLabel")}`,
      key: "fechaInicio",
      format: formatDate,
      className: "",
    },
    {
      label: `${t("documentos.facturaRec.idView.finalLabel")}`,
      key: "fechaFin",
      format: onRenderDate,
      className: "",
    },
    {
      label: `${t("documentos.facturaRec.idView.attachmentsLabel")}`,
      key: "numeroFicherosAdjuntos",
      format: getArchivosAdjuntosFormated,
      onClick: openModalAdjuntos,
      className: "adjuntos",
    },
    {
      label: `${t("documentos.facturaRec.idView.importLabel")}`,
      key: "importe",
      format: getPriceFormated,
      className: "highlighted-box",
    },
  ]
}
